import { useMutation } from '@tanstack/react-query';

import {
  addFavouriteBroadcast,
  removeFavouriteBroadcast,
} from 'api/favourites.service';
import { useToast } from 'hooks/ui';
import { useFavoritesStore } from 'store/favorites';

type ToggleVars = { broadcastId: string; favorite: boolean };

export const useFavouriteBroadcastToggle = () => {
  const toast = useToast();
  const setBroadcastFavorite = useFavoritesStore((s) => s.setBroadcastFavorite);

  const { mutate, isPending } = useMutation({
    mutationFn: async ({ broadcastId, favorite }: ToggleVars) => {
      if (favorite) {
        await addFavouriteBroadcast(broadcastId);
      } else {
        await removeFavouriteBroadcast(broadcastId);
      }
    },
    onMutate: async ({ broadcastId, favorite }) => {
      const wasFavorite = useFavoritesStore
        .getState()
        .isBroadcastFavorite(broadcastId);

      setBroadcastFavorite(broadcastId, favorite);

      return { wasFavorite };
    },
    onError: (_err, { broadcastId }, context) => {
      const revert = context?.wasFavorite ?? false;

      setBroadcastFavorite(broadcastId, revert);
      toast.error('Could not update favourite. Please try again.');
    },
  });

  return { mutate, isPending };
};
